/**
 * 用户登出
 */
export async function requestSignOut(): Promise<void> {
  return http.get('/v1/auth/logout').then(() => {
    useAccessToken().value = ''
  })
}
